// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"a59be641","629":"36aeeee7"}[chunkId] + ".chunk.js";
};